
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-order/create",
      function () {
        return require("private-next-pages/new-order/create.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-order/create"])
      });
    }
  